import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, of, switchMap } from 'rxjs';
import { LogbookAppState } from '../../logbook.reducer';
import * as ObjectActions from './logbook-state-report.actions';
import * as AppActions from '../../app/actions';
import { IGetManyResponse } from '../../../shared/model/interface/crud-response-interface.model';
import { LogbookStateReportService } from '../../../shared/service/reports/logbook-state-report/logbook-state-report.service';
import { ILogbookStateReportData } from './logbook-state-report.model';
import { emptyAction } from '../../../../constants';

@Injectable()
export class LogbookStateReportEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<LogbookAppState>,
    private readonly service: LogbookStateReportService,
  ) {}

  getLogbookStateReportData = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_LOGBOOK_STATE_REPORT_DATA),
      switchMap((action: ObjectActions.GetLogbookStateReportData) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.service.getLogbookStateReport(action.payload).pipe(
          switchMap((response: IGetManyResponse<ILogbookStateReportData>) => {
            return of(new ObjectActions.GetLogbookStateReportDataCompleted(response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  downloadExcel = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.DOWNLOAD_EXCEL),
      switchMap((action: ObjectActions.DownloadExcel) => {
        this.store.dispatch(new AppActions.ShowLoader());

        this.service.downloadExcel(action.payload, action.selectedHeaders);

        return emptyAction;
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );
}
